import { useTranslate } from '@tolgee/react';
import { useMemoizedFn } from 'ahooks';
import { useParams } from 'react-router-dom';
import {
  isValidRegion,
  regionLabelMap,
  regionMonetaryUnitMap,
  regionTimeZoneMap,
  regionUpperCaseRegionMap,
} from 'services/config/region';
import toLowerCase from 'utils/toLowerCase';

export function useRegion() {
  const { region } = useParams();

  if (isValidRegion(region)) {
    return region;
  }

  throw new Error('Invalid region of your router params');
}

export function useUpperCaseRegion(regionParam?: General.Region) {
  const currentRegion = useRegion();

  const region = regionParam || currentRegion;

  const { [region]: upperCaseRegion } = regionUpperCaseRegionMap;

  return upperCaseRegion;
}

export function useRegionLabel(regionParam?: General.Region) {
  const currentRegion = useRegion();

  const region = regionParam || currentRegion;

  const { [region]: label } = regionLabelMap;

  return label;
}

export function useRegionMonetaryUnit(regionParam?: General.Region) {
  const currentRegion = useRegion();

  const region = regionParam || currentRegion;

  const { [region]: monetaryUnit } = regionMonetaryUnitMap;

  return monetaryUnit;
}

export function useRegionTimeZone(regionParam?: General.Region) {
  const currentRegion = useRegion();

  const region = regionParam || currentRegion;

  const { [region]: timeZone } = regionTimeZoneMap;

  return timeZone;
}

export function useGetRegionLabel() {
  const { t } = useTranslate();

  return useMemoizedFn((region: General.CaselessRegion) => {
    return t(`region.${toLowerCase(region)}`);
  });
}

export { isValidRegion };
